import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Verification from "./views/Verification.vue";
import VerificationSection1 from "./views/VerificationSection1.vue";
import VerificationSection2 from "./views/VerificationSection2.vue";
import VerificationComplete from "./views/VerificationComplete.vue";
import NotFound from "./views/NotFound.vue";
import Expired from "./views/Expired.vue";

/*
import {
  VerificationApplicant,
  VerificationApplicantStart,
  VerificationApplicantIncome,
  VerificationApplicantEmail,
  VerificationApplicantComplete
} from "@/views/applicant";
*/

import VerificationApplicant from "@/views/applicant/VerificationApplicant.vue";
import VerificationApplicantStart from "@/views/applicant/VerificationApplicantStart.vue";
import VerificationApplicantIncome from "@/views/applicant/VerificationApplicantIncome.vue";
import VerificationApplicantEmail from "@/views/applicant/VerificationApplicantEmail.vue";
import VerificationApplicantComplete from "@/views/applicant/VerificationApplicantComplete.vue";

import VerificationEmailComplete from "@/views/VerificationEmailComplete.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/email/verify",
      name: "email_verify",
      component: VerificationEmailComplete,
    },
    {
      path: "/",
      name: "home",
      component: Home,
      children: [
        {
          path: "/applicant/:verifyType/:token",
          name: "verify-applicant-main",
          component: VerificationApplicant,
          children: [
            {
              path: "/verify/applicant/:verifyType/start",
              name: "verify-applicant-start",
              component: VerificationApplicantStart,
            },
            {
              path: "/verify/applicant/:verifyType/income",
              name: "verify-applicant-income",
              component: VerificationApplicantIncome,
            },
            {
              path: "/verify/applicant/:verifyType/email/:emailVerifyToken",
              name: "verify-applicant-email",
              component: VerificationApplicantEmail,
            },
            {
              path: "/verify/applicant/:verifyType/complete",
              name: "verify-applicant-complete",
              component: VerificationApplicantComplete,
            },
          ],
        },
        {
          path: "/:verifyType/:token",
          name: "verify-main",
          component: Verification,
          children: [
            {
              path: "/verify/:verifyType/section-1",
              name: "verify-section1",
              component: VerificationSection1,
            },
            {
              path: "/verify/:verifyType/section-2",
              name: "verify-section2",
              component: VerificationSection2,
            },
            {
              path: "/verify/:verifyType/complete",
              name: "verify-complete",
              component: VerificationComplete,
            },
          ],
        },
      ],
    },

    {
      path: "/404",
      name: "not-found",
      component: NotFound,
    },
    {
      path: "/expired",
      name: "expired",
      component: Expired,
    },
  ],
});

export default router;
